import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { selectors } from 'store/selectors'

import { useSession } from '@/entities/session/model/useSession'

import { mindBoxSDK } from '@/shared/integrations/mindBox'
import { getProductPageView, pushToDataLayer } from '@/shared/integrations/yandex-metric'
import { getPhoneFromJwtToken } from '@/shared/lib/utils/jwt/get-phone-from-jwt-token'
import { TProduct } from '@/shared/types/product-types'

export const useProductPagePushEvents = (product: TProduct) => {
	const categories = useSelector(selectors.categoriesItems)
	const { currentSession } = useSession()

	useEffect(() => {
		if (!product?.KOD) return
		pushToDataLayer(getProductPageView(product, categories), { debug: true })
	}, [product?.KOD])

	useEffect(() => {
		if (!product?.KOD) return
		const userPhone = getPhoneFromJwtToken(currentSession?.token)

		setTimeout(() => {
			mindBoxSDK.sendProductPageViewEvent(product.KOD, userPhone)
		}, 1500)
	}, [product?.KOD, currentSession?.token])
}
